module.exports = __webpack_public_path__ + "static/media/portrait_08.8ed8b48e.jpg";